import React from "react";

import { PageFrame } from "components/auth/PageFrame";

const PAGE_DATA = {
  title: "Alteramos sua senha!",
  subtitle: "Faça login com a nova senha para entrar na plataforma.",
  buttonText: "Fazer login",
  to: "/",
};

export const ResetSuccess = () => {
  const { title, subtitle, buttonText, to } = PAGE_DATA;
  return (
    <PageFrame
      title={title}
      subtitle={subtitle}
      buttonAnchor={{ text: buttonText, to: to }}
    />
  );
};
